export default __webpack_public_path__ + "static/media/oliver.cc581150.svg";